import * as React from 'react';

import './style.css';
import { Link } from 'react-router-dom';

export default function DescWrap({width='100%', description=null, link=null, button, name=null, title=null}){

    return(
        <div className='description-wrap'>
            <div className="name-text">
                            <p>{name},</p>
                            <p>{title}</p>
            </div>
            <div className="description-text">
                <p>{description}</p>
            </div>
            <div style={{textAlign:"left", paddingTop:"1.75rem"}}>
                {button?<Link className="image-link-arrow" to={link}><button style={{color: '#ffffff !important', right:'0', position:"relative", boxShadow:"none"}} className="pillbox half-pillbox button-color-trans-light">
                    PROČITAJTE</button></Link>:<></>}
            </div>
        </div>
    )
}
